// src/components/PlayerInfo.js

import React from 'react';

// Helper function using Percentage Net Sentiment Score
const getPlayerImageSrc = (totalSnippets, netScorePercent) => {
  // Define image paths
  const FIRE_2 = '/assets/fire2.png';
  const FIRE_1 = '/assets/fire1.png';
  const COLD_1 = '/assets/cold1.png';
  const BORED_2 = '/assets/bored2.png';
  const DEFAULT_IMAGE = '/assets/default_player.png'; // Fallback

  console.log("Image Logic Inputs (Net Score %):", { totalSnippets, netScorePercent });

  // --- Logic based on Net Score % and Volume ---
  // Use percentage thresholds now (e.g., > 10 means > 10%)

  // Rule 3: Is the net score % negative?
  if (netScorePercent < 0) {
    console.log("Image Logic (Net %): Rule 3 Match (Score % < 0)");
    return COLD_1;
  }

  // Rule 1: High Volume (>10) AND High Net Score % (>10)?
  if (totalSnippets > 10 && netScorePercent > 10) {
    console.log("Image Logic (Net %): Rule 1 Match (Total > 10, Score % > 10)");
    return FIRE_2;
  }

  // Rule 2: High Volume (>10) AND OK Net Score % (0 to 10)?
  if (totalSnippets > 10 && netScorePercent >= 0 && netScorePercent <= 10) {
    console.log("Image Logic (Net %): Rule 2 Match (Total > 10, Score % 0-10)");
    return FIRE_1;
  }

  // Rule 4: Low Volume (<10) AND Non-Negative Net Score % (>=0)?
  if (totalSnippets < 10 && netScorePercent >= 0) {
    console.log("Image Logic (Net %): Rule 4 Match (Total < 10, Score % >= 0)");
    // NOTE: Per rules, this returns BORED_2. The Vol=9, Score=30 case will hit this.
    // If you want FIRE_1 for (Vol < 10, Score > 10), uncomment the alternative block below.
    return BORED_2;

    /*
    // --- Alternative Rule 4 / User Exception Handling ---
    if (totalSnippets < 10) {
        if (netScorePercent > 10) { // High score % despite low volume
            console.log("Image Logic (Net %): User Exception (Total < 10, Score % > 10) -> FIRE_1");
            return FIRE_1;
        } else if (netScorePercent >= 0) { // Low volume, score % 0-10 (Original Rule 4 interpretation)
            console.log("Image Logic (Net %): Rule 4 Match (Total < 10, Score % 0-10) -> BORED_2");
            return BORED_2;
        }
    }
    // --- End Alternative ---
    */
  }

  // Fallback for totalSnippets === 10 (and netScorePercent >= 0)
  if (totalSnippets === 10) {
     console.log("Image Logic (Net %): Fallback (Total == 10, Score % >= 0)");
     return netScorePercent > 10 ? FIRE_2 : FIRE_1; // Use FIRE_2 if score is high% even with 10 total
  }

  // Ultimate fallback
  console.log("Image Logic (Net %): Ultimate Fallback");
  return DEFAULT_IMAGE;
};


// Updated PlayerInfo component receives netSentimentScorePercent
const PlayerInfo = ({ player, totalSnippets, netSentimentScorePercent }) => {
  // Determine the image source using the helper function
  const imageSrc = getPlayerImageSrc(totalSnippets, netSentimentScorePercent);

  console.log("PlayerInfo Props:", { totalSnippets, netSentimentScorePercent, imageSrc });

  return (
    <div className="text-center p-2">
      <img
        key={imageSrc} // Add key
        src={imageSrc}
        alt={`${player.name} status`}
        className="rounded-full w-48 h-48 md:w-60 md:h-60 mx-auto mb-3 shadow-lg object-cover"
        onError={(e) => {
            console.warn(`Failed to load image: ${imageSrc}`);
            e.target.onerror = null;
            e.target.src = '/assets/default_player.png';
          }}
        />
      <h1 className="text-xl font-bold">{player.name}</h1>
      <p className="text-base-content text-opacity-80">{player.team} - {player.position}</p>
    </div>
  );
};

export default PlayerInfo;